import { azureSqlLinkedServiceValidators } from 'shell-models-lib';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

azureSqlLinkedServiceValidators.validateAKVLinkedserviceReference = validateAKVLinkedserviceReference;
export { AzureSqlDatabaseLinkedService, azureSqlAuthRefTypes } from 'shell-models-lib';
